




























import { defineComponent, useContext } from '@nuxtjs/composition-api';
import useUrlFormatter from '~/hooks/useUrlFormatter';
import { useTranslations } from '@vue-storefront/novulo';

export default defineComponent({
  name: 'Tips',
  props: {
    inspirationList: {
      type: Array,
      required: false,
      default: () => []
    },
    productName: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup(props) {
    const context = useContext();
    const formatUrl = useUrlFormatter();
    const { translate } = useTranslations();

    const mediaUrl = (path: string): string => {
      return `${context.$config.mediaBaseURL}${path}`;
    };

    const limitedInspirations = props.inspirationList.slice(0, 4);

    return {
      mediaUrl,
      formatUrl,
      translate,
      limitedInspirations
    };
  }
});
